import React from 'react';

export function useRemainingHeight(defaultHeight = 0): [string, React.RefObject<HTMLDivElement>] {
    const [contentHeight, setContentHeight] = React.useState(defaultHeight);
    const elementRef = React.useRef<HTMLDivElement>(undefined);
    React.useLayoutEffect(() => {
        const rects = elementRef.current?.getBoundingClientRect();
        setContentHeight(rects?.height);
    }, []);
    const height = React.useMemo(() => `calc(100% - ${contentHeight}px)`, [contentHeight]);
    return [height, elementRef];
}
